import { useEffect, useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

interface GalleryItem {
  id: number;
  title: string;
  category: string;
  imageSrc: string;
}

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedTitle, setSelectedTitle] = useState<string | null>(null);
  const [filter, setFilter] = useState<string>('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const galleryItems: GalleryItem[] = [
    {
      id: 1,
      title: 'Mešano meso z žara',
      category: 'food',
      imageSrc: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 2,
      title: 'BBQ rebra',
      category: 'food',
      imageSrc: 'https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 3,
      title: 'Ambient bara',
      category: 'interior',
      imageSrc: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 4,
      title: 'Craft pivo',
      category: 'drinks',
      imageSrc: 'https://images.unsplash.com/photo-1566633806327-68e152aaf26d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 5,
      title: 'Selekcija vin',
      category: 'drinks',
      imageSrc: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 6,
      title: 'Žar mojster',
      category: 'staff',
      imageSrc: 'https://images.unsplash.com/photo-1530632789071-8543f47edb34?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 7,
      title: 'Zunanji ambient',
      category: 'interior',
      imageSrc: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 8,
      title: 'Postrežba pijač',
      category: 'drinks',
      imageSrc: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 9,
      title: 'Priprava jedi',
      category: 'food',
      imageSrc: 'https://images.unsplash.com/photo-1428515613728-6b4607e44363?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 10,
      title: 'Poletna terasa',
      category: 'interior',
      imageSrc: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 11,
      title: 'Degustacija piva',
      category: 'events',
      imageSrc: 'https://images.unsplash.com/photo-1575444758702-4a6b9222336e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 12,
      title: 'Večerna atmosfera',
      category: 'events',
      imageSrc: 'https://images.unsplash.com/photo-1566417713940-fe7c737a9ef2?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 13,
      title: 'Profesionalna ekipa',
      category: 'staff',
      imageSrc: 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 14,
      title: 'Naš sommelier',
      category: 'staff',
      imageSrc: 'https://images.unsplash.com/photo-1516600164266-f3b8166ae679?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 15,
      title: 'Praznična dekoracija',
      category: 'events',
      imageSrc: 'https://images.unsplash.com/photo-1481833761820-0509d3217039?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 16,
      title: 'Slovenska kulinarika',
      category: 'food',
      imageSrc: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    },
  ];

  const filteredItems = filter === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === filter);

  const openImage = (imageSrc: string, title: string) => {
    setSelectedImage(imageSrc);
    setSelectedTitle(title);
  };

  const closeImage = () => {
    setSelectedImage(null);
    setSelectedTitle(null);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Banner */}
      <section className="relative pt-20 h-[40vh] min-h-[300px] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1516600164266-f3b8166ae679?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
            alt="Galerija - Žar & Bar"
            className="w-full h-full object-cover"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="container mx-auto px-4 md:px-8 z-10 animate-fade-in">
          <h1 className="heading-xl text-white text-center">Galerija</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-12 animate-fade-in">
          <h2 className="heading-lg mb-4">Vtisi s Polskave</h2>
          <p className="paragraph">
            Oglejte si fotografije naših kulinaričnih stvaritev, 
            prijetnega ambienta in dogodkov pri nas.
          </p>
        </div>

        {/* Filter */}
        <div className="flex justify-center mb-8">
          <div className="flex overflow-x-auto space-x-2 pb-2">
            <button
              onClick={() => setFilter('all')}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                filter === 'all'
                  ? 'bg-barbecue-600 text-white'
                  : 'bg-muted text-foreground hover:bg-barbecue-100'
              }`}
            >
              Vse
            </button>
            <button
              onClick={() => setFilter('food')}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                filter === 'food'
                  ? 'bg-barbecue-600 text-white'
                  : 'bg-muted text-foreground hover:bg-barbecue-100'
              }`}
            >
              Hrana
            </button>
            <button
              onClick={() => setFilter('drinks')}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                filter === 'drinks'
                  ? 'bg-barbecue-600 text-white'
                  : 'bg-muted text-foreground hover:bg-barbecue-100'
              }`}
            >
              Pijača
            </button>
            <button
              onClick={() => setFilter('interior')}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                filter === 'interior'
                  ? 'bg-barbecue-600 text-white'
                  : 'bg-muted text-foreground hover:bg-barbecue-100'
              }`}
            >
              Ambient
            </button>
            <button
              onClick={() => setFilter('staff')}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                filter === 'staff'
                  ? 'bg-barbecue-600 text-white'
                  : 'bg-muted text-foreground hover:bg-barbecue-100'
              }`}
            >
              Osebje
            </button>
            <button
              onClick={() => setFilter('events')}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                filter === 'events'
                  ? 'bg-barbecue-600 text-white'
                  : 'bg-muted text-foreground hover:bg-barbecue-100'
              }`}
            >
              Dogodki
            </button>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredItems.map((item) => (
            <div 
              key={item.id} 
              className="gallery-item cursor-pointer animate-scale-in" 
              onClick={() => openImage(item.imageSrc, item.title)}
            >
              <img 
                src={item.imageSrc} 
                alt={item.title} 
                className="w-full h-64 object-cover" 
              />
              <div className="gallery-overlay">
                <h3 className="text-white font-medium">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Dialog - Simplified implementation */}
        {selectedImage && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90">
            <button 
              onClick={closeImage}
              className="absolute top-4 right-4 text-white p-2 rounded-full bg-black/50 hover:bg-black/70 transition-colors cursor-pointer"
              aria-label="Close dialog"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
            
            <div className="max-w-4xl w-full max-h-[90vh] relative">
              <img 
                src={selectedImage} 
                alt={selectedTitle || 'Gallery image'} 
                className="w-full h-auto max-h-[90vh] object-contain" 
              />
              {selectedTitle && (
                <div className="absolute bottom-0 left-0 right-0 bg-black/60 p-4 text-white">
                  <h3 className="text-xl font-medium">{selectedTitle}</h3>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <h3 className="heading-md mb-4">Ustvarite spomine z nami</h3>
          <p className="paragraph mb-8 max-w-3xl mx-auto">
            Pridružite se nam na večerji, posebnem dogodku ali samo na pijači. 
            Naj postanejo vaši trenutki del naše zgodbe.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a href="/contact" className="btn-primary">
              Rezervirajte mizo
            </a>
            <a href="/events" className="btn-outline">
              Preverite dogodke
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GalleryPage;